<div class="otp-login-container">
<div class="otp-login-card">
  <!-- Back to Login Button -->
  <div class="back-to-login-container">
    <button 
      type="button"
      class="back-to-login-btn"
      (click)="onBackToLogin()">
      <mat-icon>arrow_back</mat-icon>
      <span>{{ backButtonText }}</span>
    </button>
  </div>

  <!-- Form Title -->
  <h2 class="form-title">{{ formTitle }}</h2>
  
  <!-- Mobile Number Input Section -->
  @if (!isOtpSent) {
    <form [formGroup]="otpForm" class="form-content">
      <div class="form-group">
        <label for="mobile-label">Enter Mobile Number</label>
        <div class="mobile-input-container">
          <mat-form-field appearance="outline" class="country-code-field">
            <mat-select formControlName="countryCode" id="country-code">
              @for (country of countryCodes; track country.code) {
                <mat-option [value]="country.code">{{ country.code }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          
          <mat-form-field appearance="outline" class="mobile-number-field">
            <input matInput 
                   type="tel" 
                   id="mobile-number" 
                   placeholder="Enter Mobile Number" 
                   formControlName="mobileNumber" 
                   required>
            @if (isFieldInvalid('mobileNumber')) {
              <mat-error>{{ getFieldError('mobileNumber') }}</mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="form-group">
        <button 
          mat-raised-button 
          color="primary" 
          class="send-otp-btn" 
          type="button"
          (click)="onSendOtp()"
          [disabled]="!otpForm.get('mobileNumber')?.valid || isLoading">
          @if (isLoading) {
            <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
            <span>Sending OTP...</span>
          } @else {
            <span>{{ sendOtpButtonText }}</span>
          }
        </button>
      </div>

      <div class="instruction-text">
        <p>{{ instructionText }}</p>
      </div>
    </form>
  }

  <!-- OTP Verification Section -->
  @if (isOtpSent) {
    <form [formGroup]="otpForm" class="form-content">
      <div class="form-group">
        <label for="otp-label">Enter OTP</label>
        <mat-form-field appearance="outline" class="otp-field">
          <input matInput 
                 type="text" 
                 id="otp-input" 
                 placeholder="Enter 4 digit OTP" 
                 formControlName="otp" 
                 maxlength="4"
                 required>
          @if (isFieldInvalid('otp')) {
            <mat-error>{{ getFieldError('otp') }}</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-group">
        <button 
          mat-raised-button 
          color="primary" 
          class="verify-otp-btn" 
          type="button"
          (click)="onVerifyOtp()"
          [disabled]="!otpForm.get('otp')?.valid || isLoading">
          @if (isLoading) {
            <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
            <span>{{ isForgotPasswordMode ? 'Resetting Password...' : 'Verifying OTP...' }}</span>
          } @else {
            <span>{{ verifyOtpButtonText }}</span>
          }
        </button>
      </div>

      <div class="resend-section">
        @if (countdown > 0) {
          <p class="countdown-text">Resend OTP in {{ countdown }} seconds</p>
        } @else {
          <button 
            mat-button 
            color="primary" 
            class="resend-btn" 
            type="button"
            (click)="resendOtp()">
            Resend OTP
          </button>
        }
      </div>
    </form>
  }
</div> 
</div>